import req from './http.js'

// 取得urlview 列表
export const apiGetSetting = (org_id, container_id, keyword, limit, page, mode) => req(
    'get', 
    `/urlview?page=${page}&limit=${limit}&key=${keyword}&containerId=${container_id}&org=${org_id}&mode=${mode}`
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 取得urlview單隻
export const apiGetOneSetting = (org_id, id) => req(
    'get', 
    `/urlview/by?id=${id}&org=${org_id}`
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 新增url view
export const apiCreateSetting = (org_id, params) => req(
    'post', 
    `/urlview?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 更新url view
export const apiUpdateSetting = (org_id, id, params) => req(
    'patch', 
    `/urlview?org=${org_id}&id=${id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 刪除url view
export const apiDeleteSetting = (org_id, id) => req(
    'delete', 
    `/urlview?org=${org_id}&id=${id}`,
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 發布urlview
export const apiEnableUrlView = (org_id, id) => req(
    'patch', 
    `/urlview/activate?org=${org_id}&id=${id}`,
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 取消發布urlview
export const apiDisableUrlView = (org_id, id) => req(
    'patch', 
    `/urlview/deactivate?org=${org_id}&id=${id}`,
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 複製urlview
export const apiCopyUrlView = (org_id, id) => req(
    'post', 
    `/urlview/copy?org=${org_id}&id=${id}`,
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 預覽
// /urlview/preview?url_view_id=1&container_id=1&org=1
export const apiGetPreviewToken = (org_id, container_id, id) => req(
    'get', 
    `/urlview/preview?url_view_id=${id}&container_id=${container_id}&org=${org_id}`
).then(function(resp){
    return resp.data.data.token
}).catch(function(error){
    throw error
})

// 檢查網址+時間是否有重複設定檔
export const apiOverlaySetting = (org_id, params) => req(
    'post', 
    `/urlview/overlap?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 更新在線人數
export const apiUpdateOnlineUserPlugin = (org_id, params) => req(
    'patch', 
    `/urlview/onlineuser?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 刪除在線人數
export const apiDeleteOnlineUserPlugin = (org_id, id) => req(
    'delete', 
    `/urlview/onlineuser?id=${id}&org=${org_id}`
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 更新銷售計數器
export const apiUpdateCounterPlugin = (org_id, params) => req(
    'patch', 
    `/urlview/counter?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 刪除銷售計數器
export const apiDeleteCounterPlugin = (org_id, id) => req(
    'delete', 
    `/urlview/counter?id=${id}&org=${org_id}`,
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 新增發票搜集器
export const apiCreateInvoiceCollector = (org_id, params) => req(
    'post',
    `/urlview/invoice?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 取單隻的發票搜集器
export const apiGetInvoiceCollector = id => req(
    'get',
    `/view/invoice/iframe?id=${id}`
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiUpdateInvoiceCollector = (org_id, params) => req(
    'patch',
    `/urlview/invoice?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 刪除單隻
export const apiDeleteInvoiceCollector = (org_id, id) => req(
    'delete',
    `/urlview/invoice?id=${id}&org=${org_id}`,
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 送發票資料到後端(電子)
export const apiSendInvoice = (params) => req(
    'post', 
    `/view/invoice/qrcode`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiSendInvoiceData = (params) => req(
    'post', 
    `/view/invoice/data`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiGetInvoiceList = (container_id, page, limit, key, org_id) => req(
    'get', 
    `/urlview/invoice?containerId=${container_id}&page=${page}&limit=${limit}&org=${org_id}&key=${key}`,
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
}) 

// 取得發票資料
export const apiGetInvoiceData = (org_id, id, page, limit) => req(
    'get', 
    `/urlview/invoice/data?org=${org_id}&id=${id}&page=${page}&limit=${limit}`,
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 後台取單隻
export const apiGetInvoiceCollectorPrivate = (org_id, id) => req(
    'get',
    `/urlview/invoice/id?id=${id}&org=${org_id}`
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 匯出報表
export const apiOutputInvoiceData = (org_id, params) => req(
    'post', 
    `/urlview/invoice/output?org=${org_id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})


